interface ExtensionAuthProps {
  token: string;
  address: string;
  testnetAddress: string;
  network: string;
  isSilent?: boolean;
}

export interface IMultisigExtension {
  // TODO_R: может тут должен возвращаться Promise?
  asignaWepAppAuthRequest: (props: ExtensionAuthProps) => void;
  request: (method: string) => Promise<{ result: { token: string } }>;
  isConnected: boolean;
}

export const getExtProvider = () => {
  return (window as any).AsignaProvider as IMultisigExtension;
};

export const authenticateExtension = (props: ExtensionAuthProps) => {
  getExtProvider()?.asignaWepAppAuthRequest(props);
};

export const disconnectExtension = () => {
  getExtProvider()?.request('logoutExtension');
};

export const getConnectedInfo = () => {
  return getExtProvider()?.request('getConnectedInfo');
};
